import { api } from './api';

export const fetchTasks = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get(`/task`, payload, options);
};

export const fetchCreateTask = (payload) => {
  return api.post(`/task`, payload);
};

export const fetchTaskById = (id) => {
  return api.get(`/task/${id}`);
};

export const fetchUpdateTask = (id, payload) => {
  return api.put(`/task/${id}`, payload);
};
